"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const blueprint_1 = require("@groma-dev/blueprint");
const MenuSection_module_scss_1 = __importDefault(require("./MenuSection.module.scss"));
/**
 * The MenuSection component is a container with which aligns its children vertically.
 *
 * The `<MenuSection />` is intended to be used within the `<Menu />` component.
 * @param props
 * @constructor
 */
const MenuSection = (props) => {
    const { children, className, heading, testId } = props, args = __rest(props, ["children", "className", "heading", "testId"]);
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, args, { className: (0, blueprint_1.classNames)('Header-menuSection-local', className, MenuSection_module_scss_1.default.menuSection) }, dti, { children: [heading && (0, jsx_runtime_1.jsx)("p", Object.assign({ className: (0, blueprint_1.classNames)('Header-menuSection-heading', MenuSection_module_scss_1.default.sectionHeading) }, { children: heading })), children] })));
};
exports.MenuSection = MenuSection;
